module.exports = __webpack_public_path__ + "img/cfed9f9.svg";